import { Stripe } from '@stripe/stripe-js';
import createStripeCheckout from 'api/consult/createStripeCheckout';
import { getPaymentContext } from 'api/payments/context';

interface StripeRedirectParams {
  id: string;
  patientId: string;
  priceId: string;
  flow?: string;
}

export const stripeRedirect = async (
  { id, patientId, priceId, flow }: StripeRedirectParams,
  startStripe: (publishableKey: string) => Promise<Stripe | null>,
) => {
  const stripeCheckout = await createStripeCheckout({
    priceId,
    patientConsultId: id,
    flow,
  });

  const stripeContext = await getPaymentContext(patientId);
  const stripe = await startStripe(stripeContext.publishableKey);

  if (!stripe) {
    throw new Error('Failed to initialize Stripe');
  }

  return stripe.redirectToCheckout({
    sessionId: stripeCheckout.id,
  });
};
